<template>
    <v-card flat>
        <v-overlay :value="loadingProductData">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-toolbar color="bal-gray" dense>
            <v-toolbar-title
                >{{
                    $route.params.extProductPriceId === "new"
                        ? "Add new"
                        : activeExtProductPrice &&
                          activeExtProductPrice.ext_product &&
                          activeExtProductPrice.ext_product.name
                        ? activeExtProductPrice.ext_product.name
                        : "-" | t
                }}
            </v-toolbar-title>
            <v-spacer />

            <v-btn
                @click="handleEditClick"
                v-if="
                    $route.name === 'ext-product-price-view' &&
                        hasPermissionForAction(PermissionsConstants.PRICE_MONITORING, PermissionsConstants.EDIT)
                "
                dark
                color="bal-red"
            >
                <v-icon>edit</v-icon>
                {{ "Edit" | t }}
            </v-btn>

            <v-menu
                offset-y
                bottom
                left
                v-if="
                    $route.name === 'ext-product-price-view' &&
                        hasPermissionForAction(PermissionsConstants.PRICE_MONITORING, PermissionsConstants.DELETE)
                "
            >
                <template v-slot:activator="{ on }">
                    <v-btn color="bal-dark-gray" class="px-2 ml-2 mx-2" style="min-width: 0;" dark v-on="on">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item @click="handleDeleteClick">
                        <v-list-item-title style="color: red">{{ "Delete" | t }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-btn @click="handleSaveClick" v-if="$route.name === 'ext-product-price-edit'" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>

            <v-btn icon @click="closeDrawer()">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab style="text-transform: none !important;">
                {{ "General info" | t }}
            </v-tab>
            <v-tab-item>
                <general-view v-if="$route.name === 'ext-product-price-view'" />
                <general-edit v-else-if="$route.name === 'ext-product-price-edit'" />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Store from "../../store";
import GeneralView from "@/pages/ext-product-price/views/general-view";
import GeneralEdit from "@/pages/ext-product-price/views/general-edit";
import { PermissionsConstants } from "@/permissions";

export default {
    components: { GeneralEdit, GeneralView },
    name: "ext-product-price-view",
    data() {
        return {
            tab: 0
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (
            this.$route.params.extProductPriceId !== this.activeExtProductPrice.id &&
            this.$route.params.extProductPriceId !== "new"
        ) {
            const param = {
                id: this.$route.params.extProductPriceId
            };
            await this.getProductPriceData(param);
        }
    },
    computed: {
        PermissionsConstants() {
            return PermissionsConstants;
        },
        ...mapGetters(["hasPermissionForAction"]),
        ...mapState(["user"]),
        ...mapState("ExtProductStore", ["activeExtProductPrice", "loadingProductData"])
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions("ExtProductStore", [
            "saveActiveExtProductPriceChanges",
            "submitNewExtProductPrice",
            "deleteExtProductPrice",
            "getProductPriceData",
            "fetchProductPriceHistory"
        ]),
        handleKeyboardListener(e) {
            if (e.keyCode === 27 || e.key === "Escape") this.closeDrawer();
            if (
                document.activeElement.tagName !== "INPUT" &&
                (e.keyCode === 13 || e.key === "Enter") &&
                this.$route.name === "ext-product-price-edit"
            ) {
                this.handleSaveClick();
            }
        },
        closeDrawer() {
            if (this.$route.name === "ext-product-price-edit" && this.$route.params.extProductPriceId !== "new") {
                this.$router.push({
                    name: "ext-product-price-view",
                    params: { extProductPriceId: this.activeExtProductPrice.id }
                });
                return;
            }
            this.$router.push({ name: "ext-product-price-list" });
        },
        handleEditClick() {
            this.$router.push({
                name: "ext-product-price-edit",
                params: { extProductPriceId: this.activeExtProductPrice.id }
            });
        },
        async handleSaveClick() {
            if (this.$route.params.extProductPriceId === "new") {
                await this.submitNewExtProductPrice();
            } else {
                await this.saveActiveExtProductPriceChanges();
            }
            await this.getProductPriceData({ id: this.activeExtProductPrice.id });
            await this.fetchProductPriceHistory();
            await this.$router.push({
                name: "ext-product-price-view",
                params: { extProductPriceId: this.activeExtProductPrice.id }
            });
        },
        async handleDeleteClick() {
            if (confirm(this.t("Are you sure you want to delete this price history entry?"))) {
                await this.deleteExtProductPrice();
                await this.$router.push({ name: "ext-product-price-list" });
            }
        }
    }
};
</script>

<style scoped></style>
